import { createElement } from "react";

const VERDICT_COPY = {
  overcharged: "The difference is price, not risk.",
  underpriced: "The combined price is below what the model's correlation would justify. That can be value.",
  fair: "The bundle charge looks about right for this correlation.",
};

function factor(value) {
  return `${Number(value).toFixed(2)}x`;
}

export function CorrelationCheck({ correlationCheck }) {
  if (
    !correlationCheck?.verdict
    || !VERDICT_COPY[correlationCheck.verdict]
    || !Number.isFinite(correlationCheck.bookCorrelationFactor)
    || !Number.isFinite(correlationCheck.modelCorrelationFactor)
  ) return null;

  return createElement(
    "section",
    { className: `correlation-check correlation-check--${correlationCheck.verdict}`, "aria-label": "Correlation check" },
    createElement("h3", null, "Correlation check"),
    createElement(
      "p",
      null,
      `Your book's combined price works out to ${factor(correlationCheck.bookCorrelationFactor)} the result of multiplying its own leg prices. That premium covers correlation, extra margin, or both.`,
    ),
    createElement(
      "p",
      null,
      `The PricedPlay model says real correlation justifies ${factor(correlationCheck.modelCorrelationFactor)} for this grouping.`,
    ),
    createElement("strong", null, VERDICT_COPY[correlationCheck.verdict]),
    correlationCheck.lowConfidence
      ? createElement("p", { className: "correlation-check__confidence" }, "Very long or short entered odds make this comparison less stable.")
      : null,
    createElement(
      "small",
      null,
      "The book figure is arithmetic on the odds you entered. The model figure is a PricedPlay pricing-model estimate, not a guarantee.",
    ),
  );
}
